<template>
  <!-- 新增社保 -->
  <div class="page_addSsy">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item>
          <el-breadcrumb-item>信息维护</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/israGudSet' }">保险维护</el-breadcrumb-item>
          <el-breadcrumb-item>社保新增/编辑</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-form :model="ssyForm" :inline="true" ref="ssyForm" label-width="110px">
          <div class="info_Item_Title f_form" style="margin-bottom: 10px">
            基础信息
          </div>
          <div>
            <el-form-item label="公司名称" prop="CompanyName">
              <el-select v-model="CompanyName" placeholder="" clearable filterable @change="changeLeg">
                <el-option v-for="(item,index) in legList" :key="index" :label="item.CompanyName" :value="{label:item.CompanyName,value:item.Id}"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="参保地区" prop="RegisteredAddress">
              <div class="address flex">
                <el-cascader ref="regAddress" :props="propsAddress" v-model="area" :options="provinces" filterable></el-cascader>
                <el-input v-model="address" style="margin-left: 10px;width: 180px;"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="类型" prop="SsType">
              <el-select v-model="ssyForm.SsType" placeholder="" clearable>
                <el-option value="自营"></el-option>
                <el-option value="供应商"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="info_Item_Title f_form" style="margin-bottom: 10px">
            社保户
          </div>
          <div>
            <el-form-item label="社保户" prop="IsSsaccount">
              <el-select v-model="ssyForm.IsSsaccount" placeholder="" clearable>
                <el-option value="有"></el-option>
                <el-option value="无"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="社保对接人" prop="Ssrecipient">
              <el-select v-model="ssyForm.Ssrecipient" value-key="Userid" placeholder="" clearable filterable @change="val=>{changePerson(val,'Ssrecipient','SSRecipientId')}">
                <el-option v-for="(item,index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="社保缴纳时间" prop="SspayTime">
              <!-- <el-date-picker type="date" placeholder="选择日期" v-model="ssyForm.SspayTime"></el-date-picker> -->
              <el-select v-model="ssyForm.SspayTime" placeholder="" clearable>
                <el-option v-for="(item,index) in 31" :key="index" :label="'每月' + item + '日'" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="info_Item_Title f_form" style="margin-bottom: 10px">
            公积金户
          </div>
          <div>
            <el-form-item label="公积金户" prop="IsAfund">
              <el-select v-model="ssyForm.IsAfund" placeholder="" clearable>
                <el-option value="有"></el-option>
                <el-option value="无"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公积金对接人" prop="AfundRecipient">
              <el-select v-model="ssyForm.AfundRecipient" value-key="Userid" placeholder="" clearable filterable @change="val=>{changePerson(val,'AfundRecipient','AFundRecipientId')}">
                <el-option v-for="(item,index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公积金缴纳时间" prop="IsAfundPayTime">
              <!-- <el-date-picker type="date" placeholder="选择日期" v-model="ssyForm.IsAfundPayTime"></el-date-picker> -->
              <el-select v-model="ssyForm.IsAfundPayTime" placeholder="" clearable>
                <el-option v-for="(item,index) in 31" :key="index" :label="'每月' + item + '日'" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <!-- <div class="info_Item_Title f_form" style="margin-bottom: 10px">
            文件
          </div> -->
          <el-table :data="table" border class="ssy_table" style="width: 541px;">
            <el-table-column prop="type" label="文件类型" width="140" align="center">
            </el-table-column>
            <el-table-column prop="type" label="附件" width="200" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <div v-if="scope.row.name">{{ scope.row.name }}</div>
                <div class="info_item_sys" v-else-if="scope.row.fileUrl && !scope.row.name" @click="down(scope.$index)">查看</div>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="上传/更新" width="100" align="center">
              <template slot-scope="scope">
                <!-- <div class="info_item_sys">{{ scope.row.fileUrl ? '更新' : '上传' }}</div> -->
                <el-upload class="table_upload" action="" :on-change="(file, fileList) => {handleChangeUpload(file, fileList, scope.$index)}" :auto-upload="false" :show-file-list="false" :multiple="false">
                  <div class="info_item_sys">{{ scope.row.fileUrl ? '更新' : '上传' }}</div>
                </el-upload>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="删除文件" width="100" align="center">
              <template slot-scope="scope">
                <div class="info_item_sys" v-if="scope.row.fileUrl" @click="delUrl(scope.$index)">删除</div>
              </template>
            </el-table-column>
          </el-table>

          <div>
            <el-form-item label="工伤政策对接人" prop="InjuryContacter" style="margin-top: 15px;">
              <el-select v-model="ssyForm.InjuryContacter" value-key="Userid" placeholder="" clearable filterable @change="val=>{changePerson(val,'InjuryContacter','InjuryContacterId')}">
                <el-option v-for="(item,index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="发放派遣员工工资" prop="PayInsuranceWages" style="margin-top: 15px;" label-width="130px">
              <el-select v-model="ssyForm.PayInsuranceWages" placeholder="" clearable>
                <el-option value="是"></el-option>
                <el-option value="否"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <el-form-item label="说明" prop="Explain" style="margin-top: 15px;">
            <el-input type="textarea" v-model="ssyForm.Explain" :autosize="{ minRows: 4}"></el-input>
          </el-form-item>

          <div class="btnBox">
            <el-button type="success" @click="submitForm" v-preventReClick>保存</el-button>
            <el-button @click="backHandle">取消</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        ssyForm: {
          Id: '',
          LegalId: '', //法务主体ID
          CompanyName: '', //公司名称
          SsType: '', //类型
          RegisteredAddress: '', //参保地区
          IsSsaccount: '', //是否社保户
          Ssrecipient: '', //社保对接人
          SSRecipientId:'',
          SspayTime: '', //社保缴纳日期
          IsAfund: '', //是否公积金户
          AfundRecipient: '', //公积金对接人
          AFundRecipientId:'',
          IsAfundPayTime: '', //公积金缴纳日期
          Explain: '', //说明
          SsAccountUrl: '', //社保户URl
          IsAfundUrl: '', //公积金Url
          InvalidenrenteUrl: '', //残保金url
          InjuryPolicyUrl: '', //工伤政策url	
          InjuryContacter: '', //工伤政策对接人
          InjuryContacterId:''
        },
        CompanyName: '', //公司名称
        table: [{
          type: '社保缴费标准',
          name: '',
          fileUrl: ''
        }, {
          type: '公积金缴费标准',
          name: '',
          fileUrl: ''
        }, {
          type: '工伤保险待遇一览表',
          name: '',
          fileUrl: ''
        }, {
          type: '残保金',
          name: '',
          fileUrl: ''
        }],
        rules: {
          CompanyName: {
            required: true,
            message: "请输入公司名称",
            trigger: "blur",
          }
        },
        provinces: [], //省列表
        propsAddress: {
          label: "Name",
          value: "Name",
          children: "children"
        },
        area: '', //区域
        address: '', //地址
        headPath: this.$store.state.EMP.docPath,
        legList: [], //法务主体列表
        personnelList: [], //人员列表
        roletype: localStorage.loginRoletype,
      };
    },
    created() {
      if (this.$route.query.row != undefined && this.$route.query.row) {
        console.log(JSON.parse(this.$route.query.row))
        this.ssyForm = JSON.parse(this.$route.query.row);
        if (this.ssyForm.RegisteredAddress != undefined && this.ssyForm.RegisteredAddress) {
          this.area = this.ssyForm.RegisteredAddress.split('/')[0].split(',');
          this.address = this.ssyForm.RegisteredAddress.split('/')[1];
        }
        this.ssyForm.SspayTime = this.ssyForm.SspayTime ? Number(this.ssyForm.SspayTime) : '';
        this.ssyForm.IsAfundPayTime = this.ssyForm.IsAfundPayTime ? Number(this.ssyForm.IsAfundPayTime) : '';
        this.CompanyName = this.ssyForm.CompanyName;
        this.table = [{
          type: '社保缴费标准',
          name: '',
          fileUrl: this.ssyForm.SsAccountUrl
        }, {
          type: '公积金缴费标准',
          name: '',
          fileUrl: this.ssyForm.IsAfundUrl
        }, {
          type: '工伤保险待遇一览表',
          name: '',
          fileUrl: this.ssyForm.InjuryPolicyUrl
        }, {
          type: '残保金',
          name: '',
          fileUrl: this.ssyForm.InvalidenrenteUrl
        }]
      }
      this.getprovinces();
      this.getlegalsubjectlist();
      this.getauthUserInfoByorgancode();
    },
    methods: {
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then((res) => {
          this.provinces = res
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      changeLeg(item) {
        this.ssyForm.LegalId = item.value;
        this.ssyForm.CompanyName = item.label;
      },
      handleChangeUpload(file, fileList, index) {
        console.log(file, index)
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "bdocinf");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file.raw, file.raw.name);
        xz.uploadCert(formData).then((res) => {
          console.log("entPicFile", res);
          if (res) {
            this.table[index].fileUrl = res;
            this.table[index].name = file.raw.name;
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      delUrl(index) {
        this.table[index].fileUrl = '';
        this.table[index].name = '';
      },
      down(index) {
        var d = this.table[index].fileUrl;
        d = d.replace("\"", "").replace("\"", "");
        var path = this.headPath + d;
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      },
      // 取消
      backHandle() {
        // window.close()
        this.$router.push({
          path: "/israGudSet",
        });
      },
      //保存
      submitForm() {
        this.$refs["ssyForm"].validate((valid) => {
          if (valid) {
            if (!this.isNull(this.area)) {
              this.ssyForm.RegisteredAddress = this.area.toString() + '/' + this.address;
            }
            this.ssyForm.IsAfundPayTime = this.ssyForm.IsAfundPayTime ? this.ssyForm.IsAfundPayTime.toString() : '';
            this.ssyForm.SspayTime = this.ssyForm.SspayTime ? this.ssyForm.SspayTime.toString() : '';
            this.ssyForm.SsAccountUrl = this.table[0].fileUrl;
            this.ssyForm.IsAfundUrl = this.table[1].fileUrl;
            this.ssyForm.InjuryPolicyUrl = this.table[2].fileUrl;
            this.ssyForm.InvalidenrenteUrl = this.table[3].fileUrl;
            xz.updatess(this.ssyForm).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功')
                setTimeout(() => {
                  this.backHandle()
                }, 300);
              } else {
                this.$message.error('系统出错')
              }
            })
          }
        })
      },
       //取人员列表
       getauthUserInfoByorgancode() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "在职",
          strstation: "",
          strorgancode: ""
        }
        xz.getauthUserInfoByorgancode(data).then(res => {
          if (res.status == "ok") {
            this.personnelList = res.msg;
          } else {
            this.$message.error('获取人员列表失败')
            this.personnelList = [];
          }
        })
      },
      //选择人员
      changePerson(val,name,id){
        this.ssyForm[id] = val.Userid;
        this.ssyForm[name] = val.Username;
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_item_sys {
    color: #598DE7;
    cursor: pointer;
  }

  .info_Item_Title {
    line-height: 33px;
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", 微软雅黑, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    margin-right: 100px;
  }

  .f_form {
    border-bottom: 1px solid #ddd;
  }

  .btnBox {
    margin-top: 20px;
    padding: 20px 0 50px 0;
    width: 98%;
    display: flex;
    justify-content: center;
  }
</style>
<style>
  .page_addSsy .ssy_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_addSsy .ssy_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_addSsy .el-textarea__inner {
    width: 300px;
  }
</style>